import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import '@arco-design/web-react/dist/css/arco.css';
import '@/styles/globals.css';
import '@/lib/i18n';
import { ThemeProvider } from '@/context/ThemeContext';
import { App } from '@/App';

const container = document.getElementById('root');
if (!container) {
  throw new Error('Elemento #root nao encontrado em index.html');
}

createRoot(container).render(
  <StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </StrictMode>,
);

// F1.2: o boot dos indicadores e agora gerido pelo useMensalidadesData via
// MensalidadesProvider em App.tsx. O console.table aparece quando o hook
// completa o carregamento (auto-load em modo auto).
